import React, { FC, SVGProps } from 'react';

const Apple: FC<SVGProps<SVGSVGElement>> = props => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 28" {...props}>
    <path
      d="M13.328 6c1.226 0 2.762-.793 3.678-1.851.828-.959 1.433-2.298 1.433-3.637 0-.181-.018-.363-.052-.512-1.364.05-3.004.876-3.989 1.983-.777.843-1.484 2.166-1.484 3.521 0 .198.034.397.051.463.087.016.225.033.363.033ZM9.012 26c1.674 0 2.417-1.074 4.506-1.074 2.124 0 2.59 1.04 4.454 1.04 1.83 0 3.056-1.619 4.213-3.206 1.295-1.818 1.83-3.603 1.865-3.686-.12-.033-3.626-1.405-3.626-5.256 0-3.339 2.763-4.843 2.918-4.958-1.83-2.513-4.61-2.579-5.37-2.579-2.054 0-3.729 1.19-4.782 1.19-1.14 0-2.642-1.124-4.42-1.124-3.384 0-6.82 2.678-6.82 7.736 0 3.14 1.278 6.463 2.849 8.611C6.145 24.512 7.319 26 9.012 26Z"
      fill="#191A20"
    />
  </svg>
);

export default Apple;
